import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoWrapper } from '../../components/SeoWrapper';
import { SpecificationsDetailed } from '../../components/SpecificationsDetailed';
import { getDetailedSpecifications } from '../../selectors/newbuilding';

export function SpecificationsDetailedSeoContainer() {
  const detailedSpecifications = useSelector(getDetailedSpecifications);

  if (!detailedSpecifications) {
    return null;
  }

  return (
    <SeoWrapper>
      <SpecificationsDetailed {...detailedSpecifications} />
    </SeoWrapper>
  );
}
